import { Box } from "@mui/system";
import Loader from "../Loader";

const LoadingState = () => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "50px"
    }}
    className="loader"
  >
    <Loader height={"100%"} />
  </Box>
);

export default LoadingState;
